export const environment = {
  production: true,
  config: {
   baseUrlDotNet: 'https://webapi.truevoter.in/api',
    baseUrl: 'http://52.183.34.76:8080/truevoter',
    baseUrl1: 'http://52.183.34.76:8080/truevoter',
    baseUrlSuraj: 'http://192.168.0.121:8080/True_Voter',
    baseUrlSuraj3: 'http://192.168.0.121:8081/True_Voter',
    baseUrlSuraj1: 'http://192.168.0.121:8081/True_Voter',
    //  baseUrlDhananjoy: 'http://192.168.2.20:8082/True_Voter',
    // baseUrlNomDhananjoy: 'http://52.183.34.76:8080/Nomination',
    // baseUrlDhananjoy: 'http://truevoters.in/True_Voter',
    // baseUrlDhananjoy: 'http://api.truevoters.in/True_Voter',
    // baseUrlDhananjoy: 'http://103.118.157.211/True_Voter',
       baseUrlDhananjoy: 'https://api.truevoter.in/True_Voter',

       //baseUrlDhananjoy: 'http://localhost:8080/True_Voter',
      // baseUrlDhananjoy: 'http://192.168.2.20:8082/True_Voter',
    //  baseUrlNomDhananjoy: 'https://api.truevoters.in/Nomination',
    baseUrlNomDhananjoy: 'https://api.truevoter.in/Nomination',
    baseUrlShital: 'http://192.168.0.126:8081/True_Voter',
    baseUrlSujit: 'http://192.168.0.35:8080/True_Voter',
    baseUrlSujitNom: 'http://192.168.0.116:8080/Nomination',
    baseUrlSumeet: 'http://localhost:8090/True_Voter',
    baseUrlRatnadeep: 'http://192.168.0.20:8086/True_Voter',
    baseUrlSuraj2: 'http://192.168.0.31:8081/True_Voter'
  },

  merchantId: 'L1089929',
  paymentReturnUrl: 'https://truevoter.in/#/payment-response',
  worldlineActionUrl: 'https://www.paynimo.com/api/paynimoV2.req',
  
  // API Endpoints (called directly from Angular)
  hashServiceUrl: 'https://sos.alerto.app/web_Services/NeedlyService.svc/GenerateHashFromJson/HashGenerator',
  
};



// WEBPACK FOOTER //
// ./src/environments/environment.prod.ts